import {
  Button,
  Dialog,
  IconDelete,
  Inline,
  RadioGroup,
  RadioItem,
  Stack,
  Text,
  Textarea,
} from 'braid-design-system';
import React, { useState } from 'react';

interface ExpireListingDialogProps {
  isOpen: boolean;
  closeDialog: () => void;
  handleExpireListingConfirmed: (reason: string, comments: string) => void;
}

const ExpireListingDialog = ({
  isOpen,
  closeDialog,
  handleExpireListingConfirmed,
}: ExpireListingDialogProps) => {
  const [reason, setReason] = useState('');
  const [comments, setComments] = useState('');
  const [showError, setShowError] = useState(false);

  const onSubmit = () => {
    if (!reason) {
      setShowError(true);
      return;
    }
    handleExpireListingConfirmed(reason, comments);
  };

  return (
    <Dialog
      id="remove-listing-dialog"
      title="Remove ad"
      description={
        <Text tone="secondary">
          Please tell us why you are removing your ad.
        </Text>
      }
      open={isOpen}
      width="content"
      onClose={closeDialog}
    >
      <Stack space="large">
        <RadioGroup
          id="reason-options"
          aria-label="Reason for expirying the listing"
          value={reason}
          onChange={(event) => {
            setShowError(false);
            setReason(event.currentTarget.value);
          }}
          tone={showError ? 'critical' : undefined}
          message={showError ? 'Please select an option' : undefined}
        >
          <RadioItem
            label="I've sold or am about to sell my business via SEEK Business"
            value="sold via skb"
          />
          <RadioItem
            label="I've sold or am about to sell my business somewhere else"
            value="sold elsewhere"
          />
          <RadioItem
            label="I am no longer selling my business"
            value="no longer selling"
          />
          <RadioItem
            label="I am getting too many enquiries"
            value="too many enquiries"
          />
          <RadioItem
            label="Enquiry quality was not what I expected"
            value="enquiry quality"
          />
          <RadioItem label="I would rather not say / Other" value="other" />
        </RadioGroup>

        <Textarea
          id="comments"
          label="Is there anything else you would like to tell us?"
          value={comments}
          onChange={(event) => {
            setComments(event.currentTarget.value);
          }}
        />
      </Stack>

      <Inline
        space="gutter"
        align={{
          mobile: 'center',
          tablet: 'left',
        }}
      >
        <Button
          id="remove-listing-confirm-button"
          tone="critical"
          icon={<IconDelete />}
          onClick={onSubmit}
        >
          Remove ad
        </Button>
        <Button
          id="remove-listing-cancel-button"
          tone="neutral"
          variant="transparent"
          onClick={closeDialog}
        >
          Cancel
        </Button>
      </Inline>
    </Dialog>
  );
};

export default ExpireListingDialog;
